import { invite } from "../invite/tw";
import { property } from "../property/tw";
import { market } from "../market/tw";
import {advertise} from '../advertise/tw';
import {login, download} from '../login/tw';
import {trading} from '../trading1/tw';
import { merchandiser, common, tableList, dialog, codeInfo, hyy as contractHyy, placeOrder, codelist, panKou } from "../merchandiser/tw";
import { contest } from "../contest/tw";
import { games } from '../games/tw';
import { taskCenter } from "../task/tw"
import { ieo } from "../ieo/tw"
import { earn } from "../earn/tw"
import { apis } from "../api/tw";
import { tradingContest } from "../tradingContest/tw";
import { agent } from "../agent/tw";
import { live } from "../live/tw";
import { hongbao } from "../hongbao/tw";

const time = {
  r: "日",
  s: "時",
  f: "分",
  m: "秒",
};
// 状态
const state = {
  preheatIng: "預熱中",
  purchaseIng: "搶購中",
  over: "已結束",
  finish: "已完成",
  noData: "暫無數據",
  process: "助力中",
  sellout: "已抢完",
};
// 模板文字
const text = {
  now: "正在進行",
  start: "距離本輪開始",
  end: "距離本輪結束",
  jd: "本輪進度",
  complete: "已完成",
  limited: "限時折扣價",

  finish: "已完成",
  subscribing: "申購中",
  subscribeNow: "立即申購",
  buyStart: "距離申購開始",
  buyEnd: "距離申購結束",
  projectAmount: "項目份數",
  quota: "每份額度",
  bugPrice: "申購價格",
  buyLimit: "申購限額",
  buyAmount: "申購數量",
  buyPos: "申購幣種持倉",
  startDate: "開始時間",
  endDate: "結束時間",
  projectSuppot: "項目支持",
  websit: "項目官網",
  projectDetail: "項目介紹",
  cycle: "申購週期",
  conditionTerm:
    "開始時間前[*]日內，[**]充值數量減去提幣數量的累計值每達到[***]，可申購1份，多充多得",
  all: "全部",
  step1: "預熱",
  step2: "申購",
  step3: "搖號",
  step4: "公佈結果",
  subOrder: "申購訂單",
  myOrder: "中籤訂單",
  proCoin: "項目幣種",
  buyCoin: "申購幣種",
  orderDate: "訂單時間",
  issuanceQuota: "發放額度",
  dealAmount: "成交數量",
  dealPrice: "成交金額",
  status: "狀態",
  ctrl: "操作",
  checkOrder: "查看簽號",
  subNum: "申購簽號",
  myNum: "中籤簽號",
  status0: "已申購",
  status1: "待扣款",
  status2: "已完成",
  conditionTerm1: "申購開始時間前*日，",
  conditionTerm2: "交易對*",
  conditionTerm3: "全部交易對",
  conditionTerm4: "在幣幣交易的總金額（USDT）累計值每達到*，可申購1份",
  noData: "暫無數據",
  qgsc: "搶購鎖倉",
  yhsg: "搖號申購",
  sgsb: "申購失敗",

  supply: "本輪額度",
  rate: "兌換比例",
  successful:'兑换成功',
  ceiling: "助力上限",
  xmwc: "項目已完成",
  xmze: "項目總額",
  zkjj: "折扣均價",
  cyrs: "參與人數",
  round: "第[*]輪",
  r: "人",
  cgqg: "成功搶購",
  cgzl: "成功助力",
  xmed: "專案額度",
  kszl: "開始助力時間",
  ksqg: "開始搶購時間",
  jsqg: "結束搶購時間",
  jszl: "結束助力時間",
  hdgz: "活動規則",
  xmjs: "項目介紹",
  tcqr: "您退出確認支付後，可能將会失去本次搶購活動的機會。請謹慎操作！",
  jxtc: "繼續退出",
  fhzf: "返回支付",
  qgrsd: "當前搶購人數較多，努力搶購中，請耐心等待！",
  zltcqr: "您退出確認支付後，可能將会失去本次助力活動的機會。請謹慎操作！",
  zlqgrsd: "當前助力人數較多，請耐心等待！",
  wxts: "溫馨提示：請盡快確認支付，[*]分鐘內未完成支付將會支付超時且關閉窗口。",
};

const seckill = {
  sgno: "您尚未滿足申購條件",
  srjymm: "請輸入交易密碼",
  ljzf: "立即支付",
};
const apply = {
  condition: "申購條件",
  apply: "立即申購",
  buyPrice: "申購價格",
  buyAmount: "申購數量",
  applyAmount: "申購金額",
  forget: "忘記交易密碼?",
  noAmount: "請輸入申購數量",
  buyLimit: "申購限額",
  success: "申購成功！",
  paySummary:
    "溫馨提示：請盡快確認支付，3分鐘內未完成支付，將會支付超時且關閉窗口。",
  appFull: "申購數量過大",
  seckill_async_fail_13: "兩次申購的時間間隔為{}分鐘",
};

const seckillRes = {
  seckill_async_3: "支付中，請稍等！",
  seckill_async_5: "取消搶購成功",
  seckill_async_fail_1: "抱歉！請刷新頁面，重新嘗試！",
  seckill_async_fail_2: "抱歉！請刷新頁面，重新嘗試！",
  seckill_async_fail_3: "抱歉！請刷新頁面，重新嘗試！",
  seckill_async_fail_4: "抱歉！額度已搶完!",
  seckill_async_fail_5: "抱歉！支付已超時，請重新嘗試！",
  seckill_async_fail_6: "支付密碼輸入錯誤，請重新輸入！",
  seckill_async_fail_7: "交易密碼錯誤次數超限,請稍後再試！",
  seckill_async_fail_8: "抱歉！支付已超時,請重新嘗試！",
  seckill_async_fail_9: "抱歉！額度已搶完，期待您下次成功！",
  seckill_async_fail_10: "當前搶購人數較多，請稍候再試！",
  seckill_async_fail_11: "行為驗證校驗失敗！",
};
const header = {
  zcgl: "資產管理",
  zczh: "資產賬戶",
  bbzh: "幣幣帳戶",
  fbzh: "買幣賬戶",
  bdbzh: "幣貸寶賬戶",
  wdgl: "委單管理",
  lswt: "歷史委託",
  qbhz: "錢包互轉",
  yhzx: "用戶中心",
  wdhb: "領取紅包",
  openOrder: "當前委託",
  dealStats: "成交統計",
  totalAsset: "總資產估值",
  cz: "合約帳戶",
  gmcnyt: "購買CNYT",
  yqfy: "邀請返傭",
  hbthhr: "HBT合夥人",
  tczh: "退出帳戶",
  moreNew: "更多公告",
  gfgg: "官方公告",
  zxxw: "最新新聞",
  ckgd: "查看更多",
  bbdd: "币币订单",
  bbwhydd: "币本位永续合约订单",
  etfdd: "ETF订单",
  fbdd: "法币订单",
};
const recommend = {
  vol24h: "24H量",
  jyd: "交易對",
  jydlx: "交易對類型",
  zxj: "最新價",
  change24: "24H漲跌",
  line24: "價格趨勢（3日）",
};
const hyy = {
  ty: "同意",
  bkt: "不開通",
  wqdkt: "我確定開通",

  kt12: "1. 您在參與之前務必詳盡地了解數字貨幣合約交易的基本知識和相關風險以及參與衍生品交易所有關的業務規則等。",
  kt13: "2. 本風險提示書上述風險事項僅為列舉性質，未能詳盡的列明有關數字資產衍生品交易的所有風險因素，投資者參與數字資產衍生品交易投資前，還應該認真對其它可能存在風險因素有所了解和掌握。",
  kt14: "3. 我們誠摯的希望和建議投資者，從風險承受能力等自身實際情況出發，審慎的決定是否參與此合約交易，合理地配置自己的數字資產。",
  kt0: "親愛的用戶：",
  kt1: "您尚未開通合約賬戶及合約交易權限，請您仔細閱讀以下內容以後再決定是否開通：",
  kt2: "一、 您在合約市場進行交易，假如市場價格走勢對您不利導致您的倉位保證金不足時，BiKing永續合約會按照系統約定對您的倉位進行強平委託並披露強平明細。",
  kt3: "二、 您必須認真閱讀並遵守BiKing永續合約的業務規則，了解合約的機制和運行原理，了解市場的各種風險。",
  kt4: "四、 BiKing永續合約接入的是合約交易系統，用戶倉位的盈虧隨合約行情的波動而變化，當虧損較大時，亦會在合約交易系統中發生爆倉。請用戶您及時根據合約行情自行決定自己的交易行為，自負盈虧，據此，BiKing不承擔任何推定或者既定的保證責任。",
  kt5: "五、 請用戶自覺遵守平臺相關規則，自覺遵守相關國家地區的法律法規，若用戶合約帳戶因違規操作异常，帳戶將會被凍結，用戶將無法操作，平臺亦無法為用戶執行平倉，若由此造成損失或爆倉，平臺將不會為此承擔任何責任。",
  kt6: "六、數字資產衍生品交易可能面臨一定法域內的政策監管風險，您在交易之前需在了解交易地域的政策監管背景的前提下審慎做出判斷。由於相關國家及地區法律、法規、政策的變化、合約交易所交易規則的修改、緊急措施的出台等原因，BiKing會提前披露聲明，您持有的未平倉合約可能無法繼續持有，但保證金和盈利的結餘仍會兌現。",
  kt7: "七、	由於非平台方所能控制的原因，例如：地震、水災、火災等不可抗力因素或者計算機系統、通訊系統故障等，可能造成您的指令無法成交或者無法全部成交，由此導致的損失可能會由您自己承擔。",
  kt8: "八、	 “套期保值”交易同投机交易一样，同样面临价格波动引起的风险。",
  kta9: "九、	如果您沒有進行實名認證或者未綁定Google驗證，或者將賬號借給非本人操作，將可能會影響您的合約保證金的安全性。",
  kta10:
    "三、 在某些極端的市場情況下，您可能會難以或無法將持有的未平倉合約平倉。例如，當你的盈利在整個合約市場中有效槓桿PnL中排位第一，且對手盤在保險基金不足以墊付其穿倉損失的情況下。",

  kt9: "我已經仔細閱讀，並願意承擔風險",
  kt10: "開通合約賬號及合約交易權限",
  zjhz: "資金劃轉",
  ljhz: "立即劃轉",
  qx: "取消劃轉",
  khz: "可劃轉",
  qxz: "請選擇",
  bz: "幣種",
  c: "從",
  zz: "轉至",
  sl: "數量",
  qb: "全部",
  ktcg: "開通成功",
  ktsb: "開通失敗",
  hzcg: "劃轉成功",
  hzsb: "劃轉失敗",
  wyyd: "", //未勾选已经阅读提示文案
  tc: "退出",
  warning1: "請選擇幣種",
  warning2: "轉出賬戶不能為空",
  warning3: "轉入賬戶不能為空",
  warning4: "請輸入不大於可轉數量的數字",
  warning5: "最大保留4位小數",
  gb: "關閉",
  openSuccess: "您已開通合約交易",
  openSuccessTip: "請劃轉資金到合約帳戶",
  wsmyz: "您尚未完成實名認證",
  hdnm: "完成實名認證並累計淨劃[*]USDT可獲得[**]USDT泥碼",

  nmjl: "泥碼記錄",
  nmhzjl: "泥碼獲贈記錄",
  gxn: "恭喜您!",
  qwjy: "前往交易",
  yfrndhyzh: "已放入您的合約帳戶",
  nzxy: "您只需再向合約帳戶劃轉[*]USDT 便能獲得[**]USDT泥碼",
  nmssm: "泥碼是什麼",
  nm: "泥碼",
  nxhyzh: "您向合約帳戶",
  text1: "向合約帳戶累計淨劃轉[*]USDT以上，獲得",
  text2: "您只需再向合約帳戶劃轉[*]USDT",
  text3: "便能獲得[*]USDT泥碼",
  text4: "餘額",
  text5: "您向合約帳戶累計淨劃轉[*]USDT以上，已獲得",
  not_get_nm: "抱歉，泥碼活動已發放結束，本次劃轉未能獲得泥碼",
  yijie: "1、一阶",
  erjie: "2、二阶",
  ljjhr: "累计净划入",
  khd: "可获得",
  hysnm: "合約送泥碼",
  bbgg: "永續合約 百倍杠杆",
  hdsj: "活動時間：",
  hdxq: "活動詳情",
  ljhd: "立即領取",
  xdxd: "先到先得",
  ylnnz: "贏了你拿走，輸了算我的",
};

const Verification = {
  channel: "官方驗證通道",
  verify: "請輸入需要驗證的信息",
  notes: "安全提示",
  notes1:
    "1. 所有與BiKing相關的郵箱、微信號、QQ號、域名及媒體號均可在此進行驗證。",
  notes2: "2. 社交媒體賬號（微博、推特等）僅支持名稱查詢，需要區分大小寫。",
  notes3: "3. 如對驗證結果有疑問，可在官網或者APP內聯系官方客服進行再次確認。",
  error: "驗證失敗",
  error1: "您查詢的信息",
  error2: "不是官方認證的渠道，請註意保護資產安全，謹防私人信息泄露。",
  errorNote: "註意事項",
  errorNote1:
    "1. 目前官方驗證渠道僅支持驗證郵箱、官方微信號、QQ號、域名及社交媒體賬號 ",
  errorNote2: "2. 微信等聊天工具僅支持賬號（非昵稱）進行查詢",
  errorNote3: "3. 社交媒體賬號僅支持名稱查詢，需要區分大小寫",
  success: "驗證成功",
  success1: "您查詢的信息",
  success2: "是BiKing官方認證的",
  success3: "，若該號碼/賬號出現在其他渠道則不可信任，請註意資產安全。",
  more: "查看更多",
  know: "我已知曉",
  weChat: "微信",
  name: "域名",
  webo: "微博",
  twitter: "推特",
  email: "郵箱",
  contact: "聯系客服",
  bannerTip:
    "為防止不法分子借用BiKing名義進行詐騙，您可通過此頁面確認聯繫 您的電話、微信等是否為BiKing官方渠道。",
};
const index = {
  downloadIos: 'AppStore下載',
  downloadAndroid: '安卓下載',
  downloadGoogle: 'Google Play下載'
};

const indexPage = {
  gfgg: "官方公告",
  zxxw: "最新新聞",
  ckgd: "查看更多",
};

const NAVS = {
  xh: '現貨',
  hhjy: 'Swap交易',
  ty: '體育',
  hqsj: '行情',
  game: '遊戲',
  fx: '發現',
  sj: '數據',
  fb: "法幣交易",
  bb: "現貨交易",
  jr: "金融",
  jyds: "交易大賽",
  hbhd: "紅包活動",
  gg: "杠桿交易",
  yxhy: "永续合約",
  eft: "ETF交易",
  flhd: "福利活動",
  flzx: "福利中心",
  fast: "快速交易",
  spec: "專業交易",
  login: "登錄",
  rig: "註冊",
  downapp: "下載BiKingAPP",
  downappsum: "流暢體驗 秒速充提",
  zichan: "資産",
  order: "訂單",
  qbhz: "钱包互转",
  lang: "語言",
  calc: "計價方式",

  mb: "買幣",
  hq: "行情",
  hy: "合約",
  jy: "交易",
  lc: "賺幣",
  fs: "Fansup",
  xy: "學院",
  byxy: "BiKing學院",
  gd: "更多",
  byyx: "BiKing研選",
  coins: "COINS積分",
  yqhy: "邀請好友",
  rwzx: "任務中心",
  bbms: "用USDT購買比特幣等數字資產",
  ggms: "平台出借數字資產，放大收益與風險",
  yxms: "百倍槓桿支持，操作便捷多樣",
  etfms: "放大收益，無爆倉風險",
  pool: "共享礦池",
  czzn: '操作指南',
  gywm: '關於我們',
  zhxx: '帳戶資訊',
  gd:"跟單",
  yxhy: "永續合約",
  zjhy: "贈金合約",
  product: "产品"
};

const FOOTERS = {
  zxkf: "線上客服",
  fawu: "法律建議",

  us: "我們",
  product: "产品",
  service: "服务",
  college: "學習",

  aboutUs: "關於我們",
  rateSum: "費率說明",
  notices: "公告中心",
  helps: "幫助中心",
  verific: "官方驗證通道",
  contact: "联系我们",

  fabi: "買幣",
  bibi: "幣幣交易",
  ganggan: "杠桿交易",
  swiper: "永续合約",
  etf: "ETF交易",
  licai: "賺幣",

  apis: "API支持",
  apisNew: "API支持",
  addCoin: "上幣申請",
  vips: "VIP權益",
  downapp: "APP下載",
  files: "法律文件",

  newuser: "BiKing新手營",
  swiperSchool: "合約學院",
  assistant: "學習助手",
  digitalintroduction: "數字資產介紹",

  watchword: "世界級的綠色交易平",
  meiyitian: "每一天，讓財富發生",
  chat: "聊天室",
  shequncn: "Telegram中文社群",
  shequnen: "Telegram英文社群",
  shequnkr: "Telegram韓文社群",
};

const SIDEBAR = {
  newuser: "新手",
  guide: "引导",
  bbsq: "幣幣社群",
  hysq: "合約社群",
  gd: "固定",
  sq: "收起",
};

const banner = {
  wzwh: '使用Biking網站和/或維護您的帳戶，即表示您同意我們更新的',
  sytk: '使用條款',
  yszc: '隱私政策',
  hh: '和',
  cookie: 'Cookie政策',
  djgb: '點擊“X”即表示您承認您已閱讀並同意上述條款和政策。',
  
  title: '多元化遊戲及數字貨幣交易平台',
  marketTitle: '數字貨幣交易 我們是專業的',
  marketSubTitle: '致力於為用戶提供更為安全 穩定的加密資產衍生品交易服務',
  pathTitle: '您數字貨幣之旅的得力助手',
  pathSubTitle: '千萬用戶的選擇，你值得信賴的平台',
  jylz: '3000億美元',
  jyl: '72小時交易量',
  sxs: '加密貨幣已上線',
  zcyh: '註冊用戶',
  zdjy: '最低交易手續費',
  connectTitle: '為什麼選擇我們',
  connectSubTitle: 'BiKing助您創造、增值及保管財富',
  advantageText1: '頂級性能 · 極速交易',
  advantageSubText1: '倫敦證券交易所技術驅動，超低延遲，極速撮合',
  advantageText2: '資產保障 · 極致安全',
  advantageSubText2: '幣王符合CCSS標準，保障資產及數據安全',
  advantageText3: '高流動 · 低點差',
  advantageSubText3: '幣王合約槓桿交易，超高效率，最小滑點',
  advantageText4: '全天候服務',
  advantageSubText4: '保證系統正常運行，提供全天候客戶服務',
  advantageText5: '便捷易用',
  advantageSubText5: '提供多種訂單系統及交易工具，風險可控',
  advantageText6: '隨時隨地 · 安心交易',
  advantageSubText6: '幣王 平台提供網頁版，手機應用程式，API及FIX連接',
  netWorkTitle: '26個國家 120萬用戶的共同選擇',
  netWorkSubTitle: '致力於為用戶提供更為安全、穩定的加密資產衍生品交易服務',
  smxz: '掃碼下載',
  fxbzj: '風險保證金',
  fkbz: '讓每一筆交易都有全方位的資金風控保障',
  question1: '1.幣王交易所介紹',
  questionContent1: '幣王交易所是一家全球領先的新加坡數字資產交易平台，持有美國/加拿大MSB雙牌照，提供多種數字資產的交易、存儲、管理等服務。',
  question2: '2.幣王交易所提供哪些產品？',
  questionContent2: '幣王交易所提供以下幾種產品：永續合約 ——優深度，秒撮合;現貨交易 ——0手續，快速成交;跟單社區 ——資深交易員，穩定策略單;贈金交易 ——特有模式，福利不斷;Web錢包 ——去中心化一站式服務',
  question3: '3.如何註冊幣王交易所？',
  questionContent3: '您可以在幣王交易所官網或幣王APP進行註冊。點擊註冊 ，完成註冊流程即可使用幣王交易所進行數字貨幣投資理財。',
  question4: '4.如何通過幣王交易所購買數字貨幣？',
  questionContent4: '幣王交易所快捷買幣支持多種支付方式與多種法幣，為全球用戶提供了更多的選擇和便利，無論用戶來自哪個國家或地區，都可以方便地使用本地貨幣購買數字貨幣。',
  question5: '5.如何進行數字資產交易？',
  questionContent5: '您可以在幣王交易所選擇需要交易的數字資產，進入交易頁面後，選擇購買或出售，輸入交易數量和價格，確認交易即可。並且幣王交易所支持多種數字資產交易，包括比特幣、以太坊、萊特幣、瑞波幣等。',
  question6: '6.幣王交易所如何保障用戶資產安全？',
  questionContent6: '幣王交易所採用多層加密技術保障用戶信息和資產安全，並且採用冷熱錢包分離的存儲方式，確保用戶資產安全。',

  investor: '300W加密貨幣投資者信賴',
  transaction: '在BIKing投資、交易及成長',
  hypt: '全球安全領先的數位資產合約交易平臺',
  yjpc: '一鍵即可開平倉',
  jscrj: '極速出入金，60S開啟交易真正實現零滑點交易',
  zcpt: '注册交易即領USDT',
  email: '郵箱地址',
  phone: '手機號碼',
  zc: '注册',
  yhjaqbz: '銀行級安全保障',
  lhdmch: '0滑點秒撮合',
  qthkf: '7*24小時客服',
  rmjmhb: '熱門加密貨幣',
  jrsq: '加入Biking社群',
  hqzxhd: '獲取最新的Biking活動資訊和線上支援',
}

const navCard = {
  join: 'Join BiKing',
  hzdl: 'BiKing幣王合作代理簽約期待您的加入',
  jmrx: '代理加盟熱線：183283232998',
  contract: 'Contract online',
  yxhy: '快捷合約幣王雙合約驚喜上線',
  jylh: '交易更靈活收益更豐富',
  usa: 'USA AND CANADA MSB',
  zmjys: '海外知名交易所BIKing幣王榮獲多國合規拍照',
  fxpf: '風險即賠付安全可信賴',
  srhy: '幣王首入合約送30%真金',
  hdsj: '活動時間：2022年11月01日0點至2022年12月01日0點'
}

const choice = {
  gjyh: '26個國家120萬用戶的共同選擇',
  jyfu: '致力於為用戶提供更為安全、穩定的加密資產衍生品交易服務',
  wsmxzwm: '為什麼選擇我們',
  jsty: '極速體驗',
  jmsj: '交易介面設計結合平臺多年用戶運營經驗，流程清晰，操作便捷，更有微秒級的核心記憶體撮合科技，為用戶提供更為方便舒適的交易體驗。',
  kfx: '抗風險價格機制',
  pthybz: '平臺合約幣種價格採用多源指數集成式算灋，具有强力的風險控制能力，有效規避各種極端行情下，市場波動產生的用戶風險和損失。',
  zjaqbz: '資金安全保證',
  zjdt: '所有資金動態均有多重離線簽名完成，保證微秒級判斷，深度冷儲存資產，全面護航用戶的資金安全，為每一位用戶提供100%的銀行級安全風控。',
  jszc: '頂級技術支援',
  ptjstd: '平臺科技團隊由一批頂級的區塊鏈科技專家組成，保障用戶的極致體驗，為平臺的發展和運營提供强大的技術支援。',
  jcjz: '階梯式減倉機制',
  hqbh: '根據市場行情變化，合理觸發用戶交易風控機制，24小時為用戶的財產保駕護航。',
  kf: '24小時客服',
  ptkf: '平臺採用24小時客服輪班制，認真對待每一個用戶所遇到的問題。'
}

const plat = {
  ptgn: '平臺功能',
  zjms: '贈金模式',
  zjjs: '贈金模式為幣王團隊為全網合約用戶首發推出的特色合約新玩法，贈金模式的操作流程與實盤合約一致，開倉所獲得的盈利部分可劃轉至合約帳戶，用於繼續開倉或直接提現，獲得途徑包括：手續費實时返還，活動空投，完成任務等。',
  zcms: '全倉模式',
  zcjs: '全倉模式下，所有倉位的保證金及浮動盈虧互聯共通，且包括開倉保證金在內的所有帳戶資產做為浮動保證金。 全倉模式下具有較强的風險控制能力，但同樣當行情波動劇烈時，容易超過虧損預期。',
  zucms: '逐倉模式',
  zucjs: '逐倉模式下，每筆訂單相互獨立，根據各倉位的開倉價格獨立計算盈利及虧損。 單筆訂單的本金（或稱為保證金）虧損至最大止損點後，將會被強制平倉。 盈利至最大止盈點時，自動平倉。 當逐倉模式下有持倉單或計畫單時，將無法切換逐倉模式開倉。',
  gdgn: '跟單功能',
  gdjs: '啟動跟單功能後，跟單交易員的所有開倉平倉行為都將同步執行，僅在帳戶餘額不足或超過持倉上限的情况下無法完成同步。 若無手動取消跟單功能，跟單功能將持續開啟。',
  bfpc: '部分平倉',
  bfjs: '當持有一定數量的多倉或空倉時，可根據行情變化和盈虧情况，自由選擇的平倉金額，與此同時，持倉單的盈虧金額也將根據平倉金額與保證金總額的比例，進行等比例結算，平倉後浮盈不變。',
  fxkc: '反向開倉',
  fxjs: '系統會以市場最優價格自動幫您平掉當前所選中的持有倉位，並以市場最優價格開出反方向同等持倉數量的倉位，以避免錯過反轉行情或反轉行情來臨時來不及開倉的情况。',
  zjbzj: '追加保證金',
  zjbzjjs: '當持有一定數量的多倉或空倉時，可在當前持倉的各項參數的前提下追加保證金，加倉後倉位係數將根據開倉和加保證金時各自的倉位參數進行分權重公式計算。'
}

const risk = {
  fxbzj: '風險保證金',
  fxbz: '讓每一筆交易都有全方位的資金風控保障' 
}

const license = {
  license: '幣王榮獲MSB金融牌照',
  hgyy: '合規運營，全球佈局',
  login: '登入',
  download: '掃碼下載幣王',
  support: '支持',
  jsjy: '隨時交易極速成交',
  ljxz: '立即下載BiKing App'
}

const footer = {
  yhyh: '對用戶最友好的',
  jypt: '合約交易平臺',
  yhzc: '用戶支持',
  flsm: '費率說明',
  ggzx: '公告中心',
  yhxz: '用戶須知',
  tksm: '條款說明',
  fxzs: '風險提示',
  xylb: '協定清單',
  gywm: '關於我們',
  gy: '關於',
  lxwm: '聯繫我們',
  appxz: 'App下載',
  callus: '訂閱BIKING創世紀',
  zwzxxx: '掌握最新消息、見解和價格波動',
  zc: '注册',
  email: '郵箱地址',
  callingus: '聯繫我們',
  bqsy: '版權所有',
  tips: '溫馨提示：投資有風險，入市需要謹慎'
}

const card = {
  title: '為什麼我們是最友好的合約平臺',
  text: 'BiKing助您創造、增值及保管財富',
  djxn: '返還手續費',
  jsqd: '手續費100%實时返還大幅度降低做單成本，提升盈利機會',
  zcbz: '極速出入金',
  cssbz: '極速出入金，出金入金順暢無卡頓保證用戶資金安全的同時，不錯過每一個做單行情',
  gld: '便捷易用',
  zxhd: '完成注册&開倉僅需10秒，獨有安全風控體系保護用戶隱私，注册流程更簡單',
  qthfw: '全天候服務',
  kffw: '舒適流暢的互動體驗，金本位保證金機制24小時線上客服，交易問題實时解答',
  bjyy: '便捷易用',
  fxkk: '提供多種訂單系統及交易工具，風險可控',
  axjy: '隨時隨地 · 安心交易',
  bkms: 'BiKing平臺提供網頁版，手機應用程式，API及FIX連接'
}

const news = {
  title: '新聞 & 視野',
  text: '瞭解世界頂級加密貨幣交易所的新聞動態及事業特點',
  sy: '視野',
  ltitle: '比特幣能解决新興市場的獨特挑戰',
  ldesc: '這篇文章最初看等於Cointelegraph. 隨著區塊鏈經濟伊斯坦堡峰會（Blockchain Economy Lstanbul Summit）聚焦新興市場的發展，比特幣的普及繼續受到個案需求的驅動？…',
  more: '瞭解更多',
  xwfbs1: '新聞發佈室',
  rdesc1: '數位資產交易所BiKng贊助區區塊鏈經濟伊斯坦堡峰會2022',
  xwfbs2: '新聞發佈室',
  rdesc2: '數位資產交易所BiKng贊助區區塊鏈經濟伊斯坦堡峰會2022',
}

const info = {
  hzhb: '自動化交易平臺合作夥伴',
  qsjy: '使用交易機器人在BiKing輕鬆交易',
  quadency: 'QUADENCY',
  clpt: '專業的自動交易策略平臺',
  stacked: 'Stacked',
  glcf: '用戶可使用Stacked投資加密指數。 進行自動化交易及管理財富'
}
const menu = {
  creditCardOrder: '支付訂單',
  ptmb: 'C2C',
  dsfjy: '第三方交易',
  kjmb: '快捷買幣',
  xykmb: '信用卡買幣',
  order: '訂單',
  userOrder: '用戶訂單',
  merchantOrder: '商戶訂單',
  quickOrder: '快捷訂單',
  merchant:'商家',
  asMerchant:'成為商家',
  advertisingManage: '廣告管理',
  financialStatements: '財務報表',
  messageCenter: '消息中心',
  more: '更多',
  paymentSettings: '收款設置',
  publish: '發布廣告',
  overview: '總覽',
  aqzx: '安全中心',
  phsz: '偏好設置',
  hykhj: '合約狂歡季 交易新紀元',
  xszn: '新手指南',
  bwyjy: '幣王研究院',
  bwsq: '幣王社群',
  yhxz: '使用者需知',
  bwysp: '幣王衍生產品',
  jyxz: 'OTC交易須知'
}
const otc = {
  Realtimequotes:'即時報價僅供參考，請以第三方服務商頁面價格為準',
  Realtimequotes1:'單筆限額',
  Realtimequotes2:'參考價  （{price}）',
  Realtimequotes3:'購買',
  Realtimequotes5:'請輸入購買金額',
  Realtimequotes6:'最大',
  Realtimequotes7:'高於最大限額',
  Realtimequotes8:'數量',
  Realtimequotes9:'手續費用',
  Realtimequotes10:'支付方式',
  Realtimequotes11:'到帳時間',
  Realtimequotes12:'支付成功後10~20分鐘',
  Realtimequotes13:'確認購買',
  Realtimequotes14:'購買步驟',
  Realtimequotes15:'選擇購買的數位貨幣、支付的法定貨幣和服務商',
  Realtimequotes16:'輸入購買金額、在第三方服務商網站填寫信息，並完成支付',
  Realtimequotes17:'在BiKing資產儲值記錄中查看購買的數位貨幣，並在服務商網站查看訂單詳情',
  Realtimequotes18:'即將跳轉至 {XXXXX} 購買',
  Realtimequotes24:'溫馨提示',
  Realtimequotes19:'{XXXXX} 是由第三方獨立運作的法幣貨幣與加密貨幣交易平台所有相關服務均由{XXXXX}提供;',
  Realtimequotes20:'參考價是包含了平台手續費的價格，實際成交價格以{XXXXX}官網價格為準;',
  Realtimequotes21:'BiKing 對因使用本服務所遭受的任何損失或損害不承擔任何責任。',
  Realtimequotes22:'已知曉，立即前往',
  Realtimequotes23:'購買金額',
  Realtimequotes25:'第三方交易',
  Realtimequotes26:'請先去完善您的信箱資訊',
  Realtimequotes27:'现在完善',
  Realtimequotes28:'第三方商家名稱',
  meBuy: '我要買',
  服务商: '服務商',
  bjgq:'該報價已過期，請重新獲取報價',
  gxbj:'更新報價',
  zxkdh: '最小可兌換 {min} {symbol}',
  zdkdh: '最大可兌換 {max} {symbol}',
  Available: '可用餘額',
  Unknown: '未知',
  qxgz: '取消政策：如果買家在一天內累積200次以上取消，將限制當天的購買功能。',
  xncs: '向你出售',
  qxzzffs: '請選擇支付方式',
  qdqx: '確定取消',
  wzxx: '我再想想',
  msk: '買家收款方式',
  zhmc: '帳戶名稱',
  zhxq: '帳戶詳情',
  xzhb: '選擇貨幣',

  buyer: '買家',
  seller: '賣家',
  goSet: '去添加',
  addPayWayTitle: '添加收款方式',
  addPayWay: '你需要添加或激活至少一種收款方式，才能{type}數字貨幣',
  supportPayWay: '你需要添加並開啟{type}支持的收款方式',
  top: '置頂',
  marginTips: '你已繳納 {baseMarginPaid} USDT保證金，還需繳納不低於 {needMargin} USDT',
  eyqx: '每日取消申訴3次將會限制發起申訴，同時如果是惡意取消，經查明將會凍結賬戶，請謹慎操作！',
  qdbzgm: '確定不再購買嗎？',
  qxbtk: '取消訂單後不會退款，如您已付款，請勿取消訂單。',
  yzjbzj: '普通商家已追加保證金',
  xbjjcbzj: '需補繳基礎保證金',
  jg: '價格',
  zxjgxd: '以當前最新價格下單',
  je: '金額',

  ccxe: '超出限額',
  yebz: '餘額不足',
  qxsm: '請先實名',

  dfb: '待放幣',
  jywc: '交易完成',
  buy: '購買',
  sell: '出售',
  coin: '幣種',
  allCoin: '所有幣種',
  frenchCurrency: '法幣',
  payWay: '支付方式',
  all: '所有',
  bankCard: '銀行卡',
  zfb: '支付寶支付',
  wx: '微信支付',
  search: '查詢',
  merchant: '商家（30日完成單/30日完成率）',
  turnover: '成交量',
  completionRate: '%完成率',
  quotaOrNumber:'數量/限額',
  number: '數量',
  quota: '限額',
  price: '單價',
  paymentMethod: '收款方式',
  trade: '交易',
  handlingFee: '0手續費',
  buyUsdt: '買入USDT',
  sellBtc: '賣出USDT',
  theRemainingAmount: '剩餘數量',
  userRealName: '用戶實名',
  businessMessage: '商家留言',
  wantPay: '我要支付',
  wantSell: '我要出售',
  receive: '我将收到',
  password: '密碼',
  pleaseEnterPassword: '請輸入密碼',
  cancel: '取消',
  buyUSDT: '購買USDT',
  sellUSDT: '出售USDT',
  Paymentchannel :'支付管道（請參照服務提供方匯率為準。）',
  lumpSum: '總金額',
  agree: '如果你同意和幣王進行C2C交易，即表示你接受',
  mzsm: '幣王C2C交易法律免責聲明',
  quit: '退出',
  confirm: '確定',
  orderDetail: '訂單詳情',
  limitExceeded: '超出限額',
  quantityRemaining: '剩餘數量不足',
  cryptoTitle: '只需幾步即可輕鬆購買USDT',
  cryptoSubTitle: '全球安全領先的數字資產 合約交易平台',
  availableBalance: '可用餘額',
  sellAll: '全部出售',
  fundsTransfer: '資金劃轉',
  threeStep: '買幣僅需三步',
  advantage: '選擇幣王買賣加密貨幣的優勢',
  commonQuestion: '常見問題',
  otc_title: '使用C2C 0費率買/賣加密貨幣',
  otc_title1: '在BiKing上安全輕鬆地進行零手續費交易。 立即透過銀行轉帳、信用卡等多種付款方式交易USDT',
  commonQuestion1: '什麼是加密貨幣 C2C 交易？',
  commonQuestion2: 'C2C 交易的成本有多少？',
  commonQuestion3: '什麼是 幣王 C2C 上的商家？',
  commonQuestion4: '幣王 C2C 商家有盈利嗎？',
  commonQuestion5: '怎麼避免 C2C 詐騙？',
  commonQuestion1_desc: '加密 C2C 是指點對點加密貨幣交易，您可以直接相互交易加密貨幣，而不需要像中心化交易所那樣的中介。',
  commonQuestion2_desc: 'C2C 交易的成本可能會因平台、特定加密貨幣以及交易時的網路擁塞情況而有很大差異。然而，幣王 C2C 對加密貨幣交易收取零費用，無需中介。',
  commonQuestion3_desc: '幣王 C2C 上的商家是經過認證的用戶，可以在平台上發布交易廣告並與其他用戶進行交易。',
  commonQuestion4_desc: '幣王 C2C 商家的獲利能力取決於多種因素，包括商家的交易策略、交易頻率、買賣價差以及整體市場狀況。',
  commonQuestion5_desc: '為了防範 C2C 詐騙，請驗證對方的身份、使用安全平台、限制個人或財務數據的共享以及使用可追踪的支付方式。',
  register: '註冊',
  registerByPhone: '郵箱或手機號碼註冊',
  authentication: '身份認證',
  authenticationId: '完成身份認證，只需ID證件',
  buyCoins: '買幣',
  buyCoinsByCard: '信用卡/借記卡或銀行轉賬買幣',
  fast: '快速方便',
  easyUse: '買幣操作簡單',
  fastPayment: '只需要幾分鐘即可快速到賬。',
  multiplePayment: '多種支付方式',
  platformSupports:'平台支持多種支付方式',
  flexibleConvenient: '為用戶提供了更大的靈活性和方便性。',
  safeReliable: '安全可靠',
  measure: '採用多重安全技術和措施',
  informationSecurity: '確保資金安全，用戶信息安全。',
  questionTitle1: '1.幣王交易所介紹',
  questionSubTitle1: '幣王交易所是一家全球領先的新加坡數字資產交易平台，持有美國/加拿大MSB雙牌照，提供多種數字資產的交易、存儲、管理等服務。',
  questionTitle2: '2.幣王交易所提供哪些產品？',
  questionSubTitle2: '幣王交易所提供以下幾種產品：永續合約 ——優深度，秒撮合;現貨交易 ——0手續，快速成交;跟單社區 ——資深交易員，穩定策略單;贈金交易 ——特有模式，福利不斷;Web錢包 ——去中心化一站式服務',
  questionTitle3: '3.如何註冊幣王交易所？',
  questionSubTitle3: '您可以在幣王交易所官網或幣王APP進行註冊。點擊註冊 ，完成註冊流程即可使用幣王交易所進行數字貨幣投資理財。',
  questionTitle4: '4.如何通過幣王交易所購買數字貨幣？',
  questionSubTitle4: '幣王交易所快捷買幣支持多種支付方式與多種法幣，為全球用戶提供了更多的選擇和便利，無論用戶來自哪個國家或地區，都可以方便地使用本地貨幣購買數字貨幣。',
  questionTitle5: '5.如何進行數字資產交易？',
  questionSubTitle5: '您可以在幣王交易所選擇需要交易的數字資產，進入交易頁面後，選擇購買或出售，輸入交易數量和價格，確認交易即可。並且幣王交易所支持多種數字資產交易，包括比特幣、以太坊、萊特幣、瑞波幣等。',
  questionTitle6: '6.幣王交易所如何保障用戶資產安全？',
  questionSubTitle6: '幣王交易所採用多層加密技術保障用戶信息和資產安全，並且採用冷熱錢包分離的存儲方式，確保用戶資產安全。',

  orderType: '訂單類型',
  orderStatus: '訂單狀態',
  to: '至',
  startTime: '開始日期',
  endTime: '結束日期',
  orderNo: '訂單號',
  status: '狀態',
  totalPrice: '總價',
  numberOrFee: '交易數量/手續費',
  tradingPartners: '交易對象',
  time: '時間',
  operate: '操作',
  details: '詳情',
  noPay: '待付款',
  payed: '已付款',
  finish: '已完成',
  canceled: '已取消',
  complaint: '申訴中',
  legalCurrency: '法幣金額',
  virtualCurrency: '數位貨幣',
  virtualCurrencyAddress: '收款地址',
  paymenttype: '支付類型',
  creatTime: '創建時間',
  success: '成功',
  pending: '處理中',
  awaiting: '待確認',
  declined: '失敗',
  declined: 'Thất bại',
  deposittokens:'賣單待用戶存入代幣',
  makepayment:'買單待用戶付款',
  verification:'待校驗用戶身份',
  Transactioncancelled:'交易取消',
  Transactionrejected:'交易被拒絕',
  mjskfs: '賣家收款方式',
  mjfkfs: '買家付款方式',
  toPay: '去支付',
  ddzdqx: '若你在{payTime}內還未選擇付款方式,訂單會自動取消',
  paying: '對方正在付款...',
  fkckh: '付款參考號：',
  dfwfkqx: '若對方在{payTime}內還未付款,訂單會自動取消',
  ddqxwfck: '訂單已取消，無法查看支付信息',
  ddqxckh: '訂單已取消，付款參考號:',
  ssz: '申訴中，請等待， 付款參考號:',
  qxss: '取消申訴',
  xzfkfs: '您選擇的付款方式',
  ddywc: '訂單已完成',
  ss: '申訴',
  wcfqss: '* 訂單完成1分鐘後，才能發起申訴',
  bnfqss: '* 完成{time}小時後將不能再發起申訴',
  zxkf: '* OTC購買後，需要等待T+1天才可提現。如有疑問，請諮詢客服。',
  sjyjn: '商家已繳納{deposit} {depositName}保證金',
  wen1: '1.我什麼時候能收到款？',
  da1: '對方完成付款後，您將會收到通知提示。',
  wen2: '2.買方下單後一直沒有付款，如何處理？',
  da2: '賣方無法取消訂單，但若等待時間過長，您可以發起申訴，客服團隊將為您解決。',
  wen3: '3.未及時放行數字資產會造成什麼影響？',
  da3: '收到款項後，若您未及時確認收款，可能會造成買方提起申訴，影響您在平台的信譽；同時，未處理之前您的資產也會一直凍結在您的平台錢包裡。',
  wen4: '4.收款注意事項',
  da4: '1) 請反复確認是否真實收到對方款項，不要相信任何催促放幣的理由，確認收到款項後再點擊“確認收款”，避免造成數字資產的損失！ <br/>2) 當買方的轉款銀行賬戶與平台賬戶的實名不一致時，請注意收款風險，如有疑問，請及時申訴。',
  qzgdsjnzf: '待支付，請於{payTime} 內向{associatedAdMerchantNickname}支付 {totalAmounts} {fiatCurrency}，付款參考號：',
  nxdfgm: '你向{associatedAdMerchantNickname}（{realName}）購買{amount_s} {coinsName}',
  dfxngm: '{userNickName}（{realName}）向你購買{amount_s} {coinsName}',
  nxdfcs: '你向{associatedAdMerchantNickname}（{realName}）出售{amount_s} {coinsName}',
  dfxncs: '{userNickName}（${realName}）向你出售{amount_s} {coinsName}',
  payed: '已支付',
  dddffx: '等待對方放行……',
  njhdq: '您將獲得{quantity}{coinsName}',
  qxdd: '取消訂單',
  kfqss: '付款後超{complaintPayed}分鐘，如果對方仍未放幣，可發起申訴',
  yfkfkckh: '對方已付款，付款參考號:',
  qjkqrsk: '請盡快確認收款',
  ddnsk: '等待你收款',
  zfje: '支付金額',
  skzh: '收款賬號:',
  fkzhxm: '付款賬戶姓名:',
  qdskh: '* 請確保在自己的支付工具中收到款項後再進行確認',
  fbl: '放幣',
  dfyqrfk: '* 對方已確認付款，若{complaintPayed}分鐘後仍未能實收款項，方可發起申訴',
  jkcssk: '* 對方確認付款超24小時後，我方將不能再發起申訴，請盡快查實收款',
  qrfb: '確認放幣',
  qwbqr: '請務必確認已收到當前訂單的款項並確認金額無誤後再進行放幣',
  wyqrskzq: '我確認已收款並金額正確',
  tjssyy: '請提交申訴原因',
  srssyy: '請輸入申訴原因',
  sctpxt: '上傳圖片（選填）',
  upload: '上傳',
  zdscsz: '* 圖片最多可上傳三張，支持jpeg、jpg、png格式，請確保小於3Mb',
  sstj: '提 交',
  qrfk: '確認付款',
  fkje: '付款金額',
  sdzz: '*平台不支持自動扣款，請以本人的帳號向以上帳號自行轉帳，轉帳完成後請務必點擊付款。若轉帳後未點擊付款按鈕，造成的損失將自行承擔',
  bzts: '*轉帳時請勿備註類似BTC、USDT、BiKing等信息，否則賣家可拒',
  wfk: '未付款',
  w: '我',
  srxxfs: '輸入信息，按Enter鍵發送',
  dan: '單一',
  bnch: '無法添加相同類型的支付方式',
  sd:'閃兌',
  from:'支付',
  to:'得到',
  rate:'兌換比例',
  successful:'兑换成功',
  fees:'手續費',
  slippage:'滑點',
  standards:'手續費收取標準',
  transactionamount:'交易金額的 {num}',
  confirm:'確認兌換',
  records:'全部閃兌記錄',
  chaeckrecords:'查看全部閃兌記錄》',
  tocurrency:'消耗幣種',
  consumption:'消耗數量',
  Getcurrency:'獲得幣種',
  GetQuantity:'獲得數量',
  ExchangeStatus:'兌換狀態',
  Exchangetime:'兌換時間',
  Youwillconsume:'你將消耗',
  YouwillGET:'你將獲得',
  Converted:'您成功將 {aaa} 兌換為 {bbb}',
  recommend:'推薦',
  wcsj: "完成時間",

}
const otcMerchant = {
  bzj: '保證金',
  mmggs: '買賣廣告數',
  bx: '不限',
  ggzed: '廣告總額度',
  kzjgged: '可追加廣告額度',
  zjbzjbs: '追加保證金倍數',
  tbzss: '同步展示10條',
  tjsjsqb: '提交商家申請表',
  wcgjkycrz: '完成高級KYC認證',
  ynlx: '審核表單後，OTC專員會第一時間與您聯絡',
  
  zbzl: '準備資料',
  kssh: '快速審核',

  h1: '智能交易',
  h2: '成為C2C交易行家',
  h3: '即將成為認證商家',
  sjqy: '商家權益',
  c2cjy: '除了C2C交易<span>0費率</span>，我們還為商家提供了更多豐富多彩的權益',
  fbq: '你的法幣區',
  ptsj: '普通商家',
  xsqy: '成為認證商家，享受更多權益',
  wtd: '申請成功即可發布委託單',
  xjn: '需繳納{deposit}保證金',
  ljsq: '立即申請',
  cwptsj: '你已成為普通商家',
  cwrzsj: '你已成為認證商家',
  rzsj: '認證商家',
  xrd: '享有交易市場最高信任度',
  nbyq: '僅限Biking內部邀請',
  rzbs: '更尊貴的商家認證標識',
  pmq: '獲得優先排名權',
  kffw: '享有1對1客服服務',
  sjxy: 'OTC{level}協議',
  xsjc: '新手教程',
  jygz: '交易規則',
  close: '關閉',
  submited: '我已提交',
  submitSuccess: '提交成功',

  sqsj: '申請成為商家',
  fwxy: 'biking幣王網商家服務協議',
  xyb: '幣王網是一個專門供用戶進行數字資產交易和提供相關服務的平台。為了本協議表述之方便，公司和該網站在本協議中合稱使用“我們”或其他第一人稱稱呼。只要註冊並登錄該網站的自然人或其他主體均為本網站的用戶，本協議表述之便利，以下使用“您”或其他第二人稱。為了本協議表述之便利，我們和您在本協議中合稱為“雙方”，我們或您單稱為“一方”。',
  ptsm: '平台申明：',
  p1: '1.本網站僅作為提供數字資產交易信息、就數字資產的交易提供磋商、交易的場所，本網站不參與任何實質的數字資產交易，故交易雙方應自行謹慎判斷確定相關數字資產及/或信息的真實性、合法性和有效性，並自行承擔因此產生的責任與損失。',
  p2: '2.本網站的任何意見、消息、探討、分析、價格、建議和其他資訊均是一般的市場評論，並不構成投資建議。我們不承擔任何因依賴該資訊直接或間接而產生的損失，包括但不限於任何利潤損失。',
  p3: '3.本網站的內容會隨時更改並不作另行通知，我們已採取合理措施確保網站資訊的準確性，但並不能保證其準確性程度，亦不會承擔任何因本網站上的資訊或因未能鏈結互聯網、傳送或接收任何通知和信息時的延誤或失敗而直接或間接產生的損失。',
  p4: '4.使用互聯網形式的交易系統亦存有風險，包括但不限於軟件，硬件和互聯網鏈結的失敗等。由於我們不能控制互聯網的可靠性和可用性，我們不會對失真，延誤和鏈結失敗而承擔任何責任。',
  p5: '5.禁止使用本網站從事洗錢、走私、商業賄賂等一切非法交易活動或違法行為，若發現任何涉嫌非法交易或違法行為，本站將採取各種可使用之手段，包括但不限於凍結賬戶，通知相關權力機關等，我們不承擔由此產生的所有責任並保留向相關人士追究責任的權利。',
  p6: '6.禁止使用本網站進行惡意操縱市場、不正當交易等一切不道德交易活動，若發現此類事件，本網站將對所有惡意操縱價格、惡意影響交易系統等不道德的行為採取警告、限制交易、關停賬戶等預防性地保護措施，我們不承擔由此產生的所有責任並保留向相關人士追究責任的權利。',
  p7: '您在同意幣王網服務協議之時，即視為您已經同意平台聲明的全部內容。本協議由您與幣王網的經營者共同締結，本協議具有完整的合同效力。',
  zcbzj: '第一條：資產保證金',
  p8: '1.在商家通過平台KYC與反洗錢審查後，本平台將要求商家在其平台賬戶中存入一定的保證金，以保障其在平台上的交易安全和順暢。',
  p9: '2.保證金具體數額會在本平台上的商家的法幣資產中展示，也會在交易過程中展示給用戶。',
  p10: '3.如出現以下情形時，本平台有權對商家的保證金進行扣押等處置，其保證金會被扣押≥1個月，確定對平台和用戶造成損失的，後續會按照比例扣除保證金。',
  p11: '1)商家在交易過程中發生糾紛，且商家被判定應承擔責任並履行相應義務，而商家不予配合的；',
  p12: '2)商家與本平台上未實名的賬號進行交易的；',
  p13: '3)商家利用本平台從事任何非法行為的；',
  p14: '4)商家違反本協議或本網站上的任何法律文件規定或交易規則的；',
  p15: '5)商家涉嫌引導用戶去其他平台交易；',
  p16: '6)商家涉嫌引導用戶虛假註冊，騙取平台新用戶推廣獎勵；',
  p17: '7)商家涉嫌勸誡本平台合作夥伴的用戶轉至其他平台交易。',
  cxzg: '第二條：撤銷商家資格',
  p18: '如果出現下列情形的，本平台有權單方解除您的商家資格：',
  p19: '1.交易中多次被本平台用戶投訴的；',
  p20: '2.提交的申請材料中存在任何虛假信息的；',
  p21: '3.交易中出現欺詐等不誠信行為的；',
  p22: '4.不配合本平台客服處理訂單或故意拖延客服處理訂單的；',
  p23: '5.惡意利用本平台規則牟利的；',
  p24: '6.違反法律法規、本協議、或本網站法律文件或交易規則規定的；',
  p25: '7.存在本平台認定的不符合公序良俗、公平交易的行為；',
  p26: '8.其他違反法律法規的行為。',
  zlbh: '第三條：商家資料保護',
  p27: '1.商家資料的管理：您在申請成為商家時提交給本網站的認證資料（包括之前的實名認證材料），將不可撤銷地授權由本網站保留。本網站承諾除法定或約定的事由外，不公開、編輯或透露您的認證資料，且不將保存在本網站的非公開內容用於商業目的，但以下情形除外： 您授權本網站透露的相關信息；',
  p28: '2.本網站向國家司法及行政機關提供；',
  p29: '3.本網站向本網站關聯企業提供；',
  p30: '4.第三方和本網站一起為用戶提供服務時，該第三方向您提供服務所需的相關信息；',
  p31: '5.基於解決您與第三方民事糾紛的需要，本網站有權向該第三方提供您的身份信息。',
  sjcn: '第四條：商家承諾',
  p32: '1.接受本協議全部條款是您申請認證的先決條件。',
  p33: '2.您聲明並保證，您不得為任何非法或為本協議所禁止之目的進行認證申請。',
  p34: '3.您不得以任何可能損害、使癱瘓、使過度負荷或損害其他網站或其他網站的服務或本網站或乾擾他人對於商家申請的使用等方式使用申請服務。',
  p35: '4.您不得未經本網站許可提供的任何方式取得或試圖取得任何資料或信息。',
  p36: '5.您確認並承諾：您進行使用本網站進行交易並非出於違反法律法規或破壞本網站數字資產交易秩序的目的。',
  p37: '6.商家承諾遵守平台對進行數字資產交易的所有信息披露工作要求，按照平台要求如實提供文件、資料或信息。如商家拒絕提供平台所要求的文件、資料或信息，則乙方有權視情況做出撤銷商家資格的決定。',
  ptmz: '第五條：平台免責',
  bcfx: '以下情形，本平台不承擔任何責任：',
  p38: '1.由於您將賬戶密碼告知他人或未保管好自己的密碼或與他人共享賬戶或任何其他非本網站的過錯，導致您的個人資料洩露的；',
  p39: '2.任何由於黑客攻擊、計算機病毒侵入或發作、電信部門技術調整導致之影響、因政府管製而造成的暫時性關閉、由於第三方原因(包括不可抗力，例如國際出口的主幹線路及國際出口電信提供商一方出現故障、火災、水災、雷擊、地震、洪水、颱風、龍捲風、火山爆發、瘟疫和傳染病流行、罷工、戰爭或暴力行為或類似事件等)及其他非因本網站過錯而造成的認證信息洩露、丟失、被盜用或被篡改等；',
  p40: '3.由於與本網站鏈接的其它網站（如網上銀行等）所造成的銀行賬戶信息洩露及由此而導致的任何法律爭議和後果；',
  p41: '4.任何因用戶向本網站提供錯誤、不完整、不實信息等造成不能通過認證或遭受任何其他損失，概與本網站無關；',
  p42: '5.因非本平台之原因，您的資產被他人欺詐的。',
  ptts: '第六條：平台提示',
  p43: '1.為實現身份信息審查，本網站上可能包含指向第三方網站（如網上銀行網站）的鏈接（以下簡稱“鏈接網站”）。 “鏈接網站”非由本網站控制，對於任何“鏈接網站”的內容，包含但不限於“鏈接網站”內含的任何鏈接，或“鏈接 網站”的任何改變或更新，本網站均不予負責。自“鏈接網站”接收的網絡傳播或其它形式之傳送，本網站不予負責。',
  p44: '2.本平台只為您通過本網站進行數字資產交易活動（包括但不限於數字資產交易等服務）提供網絡交易平台服務，本網站並不作為買家或賣家參與買賣數字資產行為本身；本網站不提供任何國家法定貨幣充入和提取的相關服務。',
  p45: '3.您一旦登錄本網站、使用本網站的任何服務或任何其他類似行為即表示您已了解並完全同意本協議各項內容，包括本網站對本協議隨時所做的任何修改。',
  p46: '4.您在使用本網站過程中點擊任何標有“同意”或類似意思的按鈕的行為或以其他本網站允許的方式實際使用本網站提供的服務時，均表示您完全了解、同意且接受本協議項下的全部條款的約束，無您手寫的書面簽字就本協議對您的法律約束力無任何影響。',
  p47: '5.我們保留不時修訂本協議、並以網站公示的方式進行公告、不再單獨通知您的權利，變更後的協議會在本協議首頁標註變更時間，一經在網站公佈，立即自動生效。',
  tyxy: '我同意該協議內容',
  nextStep: '下一步'
}
const user = {
  txxz: '修改資金密碼24小時不可提現',
  name: '暱稱',
  rzdj: '身份認證等級',
  phone: '手機',
  email: '郵箱',
  zzc: '資產估值',
  hours24: '24小時',
  market: '市場行情',
  notice: '公告',
  more: '更多>>',
  cb: '充幣',
  tb: '提幣',
  hz: '劃轉',
  wsm: '未實名',
  cjrz: '初級認證',
  gjrz: '高级认证',
  qwgjrz: "前往高級認證",
  aqszx: '已完成安全設置項',
  xgaqszx: '修改您的安全設置項',
  dlmm: '登錄密碼',
  zjdl: '通過設置登錄密碼，您將可以使用賬號和登錄密碼直接登陸',
  ghmm: '更換密碼',
  sz: '設置',
  jymm: '交易密碼',
  yzjymm: '賬戶資金變動時，需先驗證交易密碼。',
  ghjymm: '更換交易密碼',
  sjyz: '手機驗證',
  yzdx: '用於登錄、提現、修改密碼、安全設置時收取驗證短信',
  xgsj: '修改手機號',
  zwbd: '暫未綁定',
  ggyz: '谷歌驗證',
  syzn: '使用指南',
  bd: '綁定',
  yxyz: '郵箱驗證',
  tbqr: '您可以綁定一個常用郵箱、用於登錄、找回密碼、提幣時的確認',
  bdyx: '綁定郵箱',
  xgyx: "修改信箱",
  xyx: "新信箱",
  dljl: '最近十條登錄記錄',
  zjdljl: '這是您最近的10條登錄歷史',
  dlsj: '最近登錄時間',
  ip: 'IP地址',
  aqsz: '安全設置',
  yhdl: '用戶登錄',
  xgbdsj: '修改綁定手機',
  bdsj: '綁定手機',
  dxyzm: '短信驗證碼',
  second: '秒',
  fsyzm: '發送驗證碼',
  xsjh: '新手機號碼',
  ggyzm: '谷歌驗證碼',
  yxyzm: '郵箱驗證碼',
  confirm: '確 定',
  edit: '修改',
  name: '姓名',
  srxm: '請輸入姓名',
  zjlx: '證件類型',
  xzzjlx: '請選擇證件類型',
  zjhm: '證件號碼',
  srzjhm: '請輸入證件號碼',
  zcsr: '請再次輸入密碼',
  mmbyz: '兩次輸入密碼不一致!',
  sfz: '身份證',
  jgz: '軍官證',
  hz: '護照',
  jmtxz: '台灣省居民通行證',
  gatxz: '港澳居民通行證',
  hwid: '海外ID',
  srdx: '請輸入短信驗證碼',
  sryx: '請輸入郵箱驗證碼',
  srgg: '請輸入谷歌驗證碼',
  jdlmm: '舊登錄密碼',
  xdlmm: '新登錄密碼',
  qrxmm: '確認新密碼',
  qrdlmm: '確認登錄密碼',
  jjymm: '舊交易密碼',
  xjymm: '新交易密碼',
  qrjymm: '確認交易密碼',
  qwcyz: '請完成驗證',
  smrz: '請先進行實名認證',
  sryzm: '請輸入驗證碼',
  srsjh: '請輸入手機號',
  xgdlmm: '修改登錄密碼',
  szdlmm: '設置登錄密碼',
  xgjymm: '修改交易密碼',
  szjymm: '設置交易密碼',
  czmm: '重置密碼',

  bdgg: '綁定谷歌驗證器',
  lbyzq: '請下載谷歌兩步驗證器',
  smewm: '使用谷歌兩步驗證器掃碼二維碼',
  srdm: '如果二維碼無法識別，請手動輸入下列代碼',
  copy: '複製',
  copySuccess: '複製成功',
  sryx: '請輸入郵箱',
  srzqyx: '請輸入正確的郵箱地址',
  srsjyzm: '請輸入手機驗證碼',
  sryxyzm: '請輸入郵箱驗證碼',
  srggyzm: '請輸入谷歌驗證碼',
  passwordTypeError: '密碼格式錯誤，密碼必須是8-32位，同時包含大小寫字母和數字。',
  passwordDiff: '兩次密碼不一致',
  zcsrxmm: '請再次輸入密碼',
  language: '語言',
  bdhb: '本地貨幣',
  wdbph: '穩定幣偏好',
  "相关问题": "相關問題",
  "为什要进行身份认证": "為什麼要進行身份驗證",
  "上传中": "上傳中...",
  "开始上传": "開始上傳",
  "请手持身份证正面": "請手持身份證正面，將其放置於面部下方",
  "正对摄像头": "正對攝像頭，保持5秒以上",
  "摘下眼镜": "摘下眼鏡，帽子等遮擋物",
  "请按视频文字提示录制视频": "請按照視頻文字提示錄制視頻",
  "开始录制": "開始錄制",
  "第一段视频": "第一段視頻",
  "第二段视频": "第二段視頻",
  "录制一段视频": "錄制一段視頻",
  "点击开始录制": "點擊開始錄制",
  "视频录像认证": "視頻錄像認證",
  "身份证号": "身份證號",
  证件验证: "證件驗證（照片/掃描件）",
  zjyz: "證件驗證",
  "请确保图片格式为": "請確保圖片格式為jpg/jpeg/png，並確保圖片尺寸小於2MB",
  "请手持证件照": "請手持證件照和個人簽名，個人簽名需要包括Biking+當天日期",
  "当日签名照": "手持證件照+當日簽名照",
  "上传证件签名页": "上傳證件簽名頁",
  "请保证所有信息清晰": "請確保所有信息清晰",
  "上传证件页信息": "上傳證件頁信息",
  "请选择国家": "請選擇國家",
  "请选择区域": "請選擇區域",
  "认证要求": "認證要求",
  "证件信息": "證件信息",
  "人脸识别": "人臉識別",
  "立即认证": "立即認證",
  "什么是加密货币P2P交易": "什麼是加密貨幣P2P交易",
  "最好的P2P加密货币交易所是什么": "最好的P2P加密貨幣交易所是什麼？",
  "P2P交易的成本有多少": "P2P交易的成本有多少？",
  "什么是BikingP2P上的商家": "什麼是Biking P2P上的商家？",
  "我们正在审核您的申请": "我們正在審核您的申請",
  "预计审核时间": "預計審核時間：72小時",
  "驳回": "駁回",
  "未提交": "未提交",
  "手续费等级": "手續費等級",
  "去认证": "去認證",
  "开通更多权限": "認證身份，開通更多權限",
  "在别人贪婪时要保持警惕": "在別人貪婪時要保持警惕，而在別人警惕時就要貪婪 ——巴菲特",
  kyc声明: '我是{Name}，證件號碼是：{No}。我自願在Biking註冊和進行交易，並保證帳戶是本人使用。我保證所有的資產來源合法，已經了解並能承受全部交易風險。提取的數字資產不做非法使用，也不會在本平台進行任何非法活動，例如洗錢、傳銷和非法兌換外幣等。',
  編輯頭像:"編輯頭像",
  請選擇一個頭像用作您個人資料的照片:"請選擇一個頭像用作您個人資料的照片",
  中國:"中國",
  其他:"其他",
  questionTitle1: '1.為什麼需要提供實名認證？',
  questionSubTitle1: '幣王採用全球合規化身份驗證服務，保障所有用戶的資金安全。因此，在填寫信息時，請務必提供符合要求的材料。',
  questionTitle2: '2.完成身份認證有什麼好處？',
  questionSubTitle2: '所有用戶均須完成實名認證，方可訪問幣王的OTC功能。尚未完成實名認證的用戶，不影響鏈上充值提現。',
  questionTitle3: '3. 如何更新身份認證？',
  questionSubTitle3: '若您的身份信息發生更改且符合以下條件時，您可以聯繫在線客服提交申請更新身份認證理由：',
  questionTitle4: '4. KYC認證需要多長時間？',
  questionSubTitle4: '您提交的信息通常會在5分鐘內得到審核。 但是，如遇特殊情況可能需要更長的時間。',
  questionTitle5: '5. 幣王身份認證安全嗎？',
  questionSubTitle5: '幣王身份認證是安全的，它幫助我們為您和其他所有用戶打造安全的平臺。 您的文件對我們也是保密的。',
  questionTitles:'1. 證件已過期；',
  questionTitles1:'2. 證件上的姓名已更改；',
  questionTitles2:'3. 證件上的身分證號碼已變更；',
  questionTitles3:'4. 國籍已變更；',
  questionTitles4:'5. 更新證件，以確保正常使用法幣；',
  questionTitles5:'6. 更改為系統語言識別的姓名（例如：從本國身份證改為護照）；',
  Z1001: "系統錯誤",
  Z1003: "驗證中斷",
  Z2002: "網絡錯誤",
  Z2003: "客戶端設備時間錯誤",
  Z2006: "認證失敗",
  Z5050: "人臉驗證成功",
  Z5051: "上傳刷臉圖片失敗",
  Z5052: "數據錯誤或程序異常。",
  Z5053: "網絡錯誤。",
  Z5054: "攝像頭無權限或無法獲取攝像頭數據。",
  Z5055: "用戶退出。",
  Z5056: "重試次數過多。",
  Z5057: "視頻上傳超時。",
  Z5058: "視頻格式不滿足要求。",
  Z5059: "視頻中無有效人臉。",
  Z5128: "驗證不是同一個人。",
  法幣充值:'法幣充值&提現限額',
  無限額:'無限額',
  數字貨幣充值:'數字貨幣充值',
  數字貨幣提現限額:'數字貨幣提現限額',
  C2C交易限額:'C2C交易限額',
  h5smrz: "實名認證",
  bhzhan: "設定密碼，保護您帳號安全",
  jxsmrz: "進行實名認證，確保使用者資金安全",
  qwrz: "前往認證",
  dgzhzd: "1.單一帳號，每日最多提交5次",
  rhzp: "2.您提交的任何照片、影片或文件詳細資料都不會被儲存或以任何方式使用",
  sfzm: "身分證明",
  zjqfg: "證件簽發國家",
  dw: "定位",
  sfxx: "身分資訊",
  dqdw: "目前定位",
  gjdq: "國家",
}
const h5 = {
  chart: '圖表',
  mmp: '買賣盤',
  sscj: '實時成交',
  wt: '委託',
  lswt: '歷史委託',
  zj: '資金',
  sj: '市價',
  ky: '可用',
  zczh: '資產折合',
  dj: '凍結',
  zwsj: '暫無數據',
  zx: '自選',
  buysell: '買入/賣出'
}

const worldCup = {
  common: {
    cancel: '取消',
    confirm: '確認',
    iKnow: '我知道了',
    points: '積分',
    day: '天',
    hour: '小時',
    minute: '分',
    second: '秒',
    noData: '暫無數據',
    noMatch: '暫無比賽',
    businessClosed: '業務已關閉',
    loadFailed: '加載失敗，請稍後重試',
  },
  index: {
    liveFeed: '實時動態',
    heroTitle: '競猜世界盃',
    heroSplit: '瓜分',
    heroPrizePool: '獎池',
    heroMillionPrizePool: '瓜分百萬獎池',
    heroSub: '更有Tesla和世界盃門票等你來拿',
    heroJoinedPrefix: '已有',
    heroJoinedSuffix: '人蔘與，獎池持續增長中',
    activityTimeLabel: '活動時間：',
    refreshing: '刷新中...',
    releaseToRefresh: '鬆開立即刷新',
    pullToRefresh: '下拉刷新',
    livePrizePool: '實時獎池',
    growing: '實時增長中',
    userPoolRatioLabel: '個人用戶可瓜分獎池：',
    teamPoolRatioLabel: '團隊可瓜分獎池：',
    poolCountdownLabel: '距離瓜分第{phase}階段獎池倒計時',
    poolCountdownFinalLabel: '距離瓜分最終階段獎池倒計時',
    poolActivityStartCountdownLabel: '距離活動開始',
    poolSplitDoneBadge: '獎池已完成瓜分',
    totalAllocatedPoolLabel: '總瓜分獎池',
    poolAllocateFirst: '第一次瓜分',
    poolAllocateSecond: '第二次瓜分',
    poolAllocateThird: '第三次瓜分',
    poolAllocateFinal: '最終瓜分',
    poolTeamPrefix: '戰隊：',
    poolPersonalPrefix: '個人：',
    poolPersonalCount: '個人：{n}人',
    teamTitle: '組建戰隊，收益翻倍',
    teamSubPrefix: '加入戰隊，有機會提升',
    teamSubSuffix: '收益',
    teamAgentTitle: '代理戰隊',
    teamAgentDesc: '平臺代理可一鍵組建戰隊，<span class="wc-hl">團隊成員積分將彙總爲團隊總積分</span>，同時完成團隊任務可獲得團隊<span class="wc-hl">額外加分</span>，團隊積分越高，<span class="wc-hl">瓜分獎池</span>機會會越大。',
    createTeamNow: '立即組建戰隊',
    applyAgentNow: '我不是代理，立即申請',
    teamUserTitle: '自由戰隊',
    teamUserDesc: '無需成爲代理，可加入自由戰隊，與其他自由用戶組建團隊，共同參與<span class="wc-hl2">團隊積分</span>，獲得<span class="wc-hl2">獎池瓜分</span>機會。',
    joinNow: '立即加入',
    championTitle: '冠軍預測',
    championSub: '每個用戶只可預測一次，鎖定後不可更改，猜中獲得個人瓜分獎池的資格',
    championHintPrefix: '預測正確冠軍的用戶可獲得獎池',
    championHintSuffix: '的瓜分資格',
    championPoolShare: '的瓜分資格',
    championWin: '恭喜您猜中冠軍',
    championLose: '很遺憾，您未猜中',
    championWinSub: '獲得瓜分個人獎池的名額',
    championNoParticipation: '活動結束，您未參與競猜',
    confirmPredict: '確認預測',
    predictCountdown: '預測倒計時',
    predictEnded: '預測已結束',
    notice1: '用戶 p***12 剛完成競猜，贏得 500 積分',
    notice2: '用戶 k***88 剛兌換 Tesla 一輛',
    notice3: '用戶 a***23 剛完成競猜，贏得 1200 積分',
    notice4: '用戶 x***56 邀請好友獲得 100 積分',
    notice5: '用戶 m***07 剛兌換世界盃門票 1 張',
    tabPredict: '競猜',
    tabTask: '任務',
    tabRank: '排行',
    tabExchange: '兌換',
    tabMine: '我的',
    tabRules: '規則',
  },
  toast: {
    refreshSuccess: '刷新成功',
    predictSuccess: '競猜成功，已提交結果',
    inviteJumping: '跳轉邀請頁面...',
    applyAgentPending: '代理申請功能開發中，敬請期待！',
    championLocked: '冠軍預測已鎖定！',
    exchangeSubmitted: '兌換申請提交成功，等待平臺客服聯繫您進行獎品發放。',
    pointsNotEnough: '積分不足',
    createTeamSubmitted: '戰隊創建成功',
    joinedFreeTeam: '已加入自由戰隊',
  },
  section: {
    predictTitle: '賽事競猜',
    predictSub: '預測比賽結果，猜對+{correctPoints}積分，猜錯+{wrongPoints}積分',
    predictRules: '競猜說明',
    taskTitle: '完成任務賺積分',
    taskSub: '多種任務，多重獎勵，加速積累收益',
    exchangeTitle: '積分兌換商城',
    exchangeSub: '豐富獎品，先到先得',
    exchangeRules: '兌換說明',
    rankTitle: '實時排行榜',
    rankSub: '比拼實力，衝擊榜首',
    rulesTitle: '活動規則',
    rulesSub: '透明公開，公平公正',
  },
  dialog: {
    taskTitle: '任務說明',
    taskReward: '完成後可獲得',
    predictConfirmTitle: '賽事競猜',
    predictConfirmHint: '你猜哪隻隊伍會獲勝？',
    predictPay: '支付',
    predictPayTip: '從資金賬戶扣除，請確保餘額充足',
    predictConfirmBtn: '確認競猜',
    predictSuccessTitle: '競猜成功',
    predictSuccessDesc: '已成功提交競猜結果，可在“我的競猜”中查看記錄。',
    exchangeTitle: '商品兌換',
    exchangeNeedPoints: '所需積分',
    exchangeBalance: '餘額：',
    exchangeContactTitle: '至少填寫一種聯繫方式',
    exchangeTipTitle: '溫馨提示',
    exchangeTip1: '請至少填寫一種聯繫方式，提交後平臺客服會聯繫您進行獎品發放的溝通。',
    exchangeTip2: '如果長時間與您未聯繫，請主動聯繫客服進行處理。',
    exchangeConfirm: '確認兌換',
    teamJoinTitle: '加入團隊',
    teamCreateDesc: '確認組建戰隊？',
    teamJoinFreeDesc: '您確認加入自由戰隊？',
    teamJoinTipTitle: '溫馨提示',
    teamJoinTipDesc: '您是屬於代理團隊成員，不能加入自由戰隊，您可邀請您的邀請者（代理人）一起組隊參加團隊對戰。',
    applyAgentContactTitle: '重要提示',
    applyAgentContactPrefix: '請添加 Telegram：',
    applyAgentContactSuffix: '以申請成為代理。成為代理後，即可建立戰隊。',
    applyAgentContactBtn: '知道了',
  },
  rank: {
    teamRank: '戰隊排行',
    personRank: '個人排行',
    yourTeamRank: '你的戰隊排名',
    yourPersonRank: '你的個人排名',
    captain: '隊長：',
    currentPoints: '當前積分',
    members: '成員',
    teamDetail: '團隊詳情',
    noRankYet: '暫無排行',
  },
  mine: {
    myPoints: '我的積分',
    totalPoints: '總積分',
    myPredict: '我的競猜',
    myExchange: '我的兌換',
    myBonus: '我的獎金',
    totalBonus: '我獲得的總獎金',
    bonusPhase: '瓜分階段：',
    bonusPhaseFirst: '第一階段',
    bonusPhaseSecond: '第二階段',
    bonusPhaseThird: '第三階段',
    bonusPhaseFinal: '最終階段',
    bonusTypeTeam: '團隊瓜分',
    bonusTypePersonal: '個人瓜分',
    bonusPoints: '瓜分時積分：',
    bonusType: '類型：',
    bonusAmount: '獎金：',
    totalCount: '共 {total} 條',
    myTeam: '我的戰隊',
    selectTeam: '選擇隊伍',
    predictMatch: '比賽',
    winTeam: '獲勝隊伍',
    predictResult: '競猜結果',
    hit: '猜中',
    miss: '未猜中',
    draw: '平局',
    exchangeItem: '兌換物品',
    contactInfo: '聯繫方式',
    exchangeStatus: '兌換狀態',
    currentRank: '當前排名',
    notJoinedTeam: '未加入戰隊',
    memberContribution: '團員貢獻',
    teamTaskContribution: '團隊任務貢獻',
    loading: '加載中...',
    statusDone: '已完成',
    statusPending: '處理中',
    statusFail: '兌換失敗',
    logCompleteKyc: '完成KYC',
    logExchangePrize: '獎品兌換',
    logMatchPredict: '賽事競猜',
    logDailySign: '每日簽到',
    logFinishTask: '完成任務',
    taskFirstRecharge: '完成首次充值 >= {amount} USDT',
    pagerTotal: '共 {total} 條',
    prevPage: '上一頁',
    nextPage: '下一頁',
    goTo: '前往',
    page: '頁',
  },
  mobile: {
    title: '世界盃競猜',
  },
  nav: {
    entry: '世界盃競猜',
  },
  mock: {
    korea: '韓國',
    germany: '德國',
    china: '中國',
    uk: '英國',
    france: '法國',
    portugal: '葡萄牙',
    senegal: '塞內加爾',
    brazil: '巴西',
    india: '印度',
    turkiye: '土耳其',
    usa: '美國',
    jerseyPack: '官方球衣套裝',
    vipCard: 'VIP 加密會員卡',
    jerseyKeyword: '球衣',
  },
  predict: {
    round: {
      group: '小組賽',
      r32: '32強賽',
      r16: '16強賽',
      quarter: '1/4決賽',
      semi: '半決賽',
      third: '季軍賽',
      final: '決賽',
    },
    status: {
      joined: '已參與',
      open: '開放競猜',
      ongoing: '比賽中',
      ended: '已結束',
    },
    btn: {
      joined: '已競猜',
      open: '{betPaymentAmount}USDT 立即競猜',
      ongoing: '比賽進行中',
      ended: '競猜已結束',
    },
    joinedMatchPhase: {
      pending: '未開始',
      ongoing: '進行中',
      ended: '已結束',
    },
    joinedResult: {
      hit: '猜中 +{points}',
      missPrefix: '猜錯',
      missSuffix: '+{points}',
    },
  },
  rules: {
    fundSource: '資金來源',
    poolSplit: '獎池瓜分',
    teamIntro: '戰隊說明',
    poolRulesTitle: '獎池說明',
    teamRulesTitle: '戰隊說明',
    predictRulesTitle: '競猜說明',
    exchangeRulesTitle: '兌換說明',
  },
  rulesText: {
    poolDesc1: '活動初始獎金 {initialFunds} USDT，活動有效時間內，部分業務獎金按照比例投入獎池，不斷提高獎池總額',
    poolLine1: '每筆充值金額的 {rechargePercentageToPool}% 自動進入獎池；',
    poolLine2: '每筆永續合約交易手續費的 {contractFeePercentageToPool}% 自動進入獎池；',
    poolLine3: '每完成一位有效邀請用戶，獎池自動增加 {additionalAmountPerValidUser} USDT。',
    poolLine4: '*低於 0.01 USDT 將不會計入獎池。',
    teamPoolTitle: '團隊瓜分獎池',
    teamPoolRuleTitle: '團隊瓜分規則',
    teamPoolRule1: '團隊獲得獎金後，隊長（自由戰隊除外）獲得瓜分獎金的20%，隊長獎金 = 總獎池 * 該次瓜分比例 * 20%',
    teamPoolRule2: '獲得瓜分資格的團隊成員根據個人積分貢獻權重分配獎金，隊員瓜分金額 = [(總獎池 * 該次團隊瓜分比例) * (1 - 0.2) / 具備瓜分資格的團隊成員積分之和] * 個人總積分',
    userPoolTitle: '個人用戶瓜分獎池規則',
    poolSplit1: '第一次：8 強隊伍確定後，積分排名第一名團隊瓜分 {percentage}% 獎池，餘額繼續累積',
    poolSplit2: '第二次：4 強隊伍確定後，積分排名第一名團隊瓜分 {percentage}% 獎池，餘額繼續累積',
    poolSplit3: '第三次：半決賽結束後，積分排名第一名團隊瓜分 {percentage}% 獎池，餘額繼續累積',
    poolSplit4: '最終：決賽結束後，積分排名第一名團隊瓜分 全部獎池的 {percentage}%，瓜分結束後，團隊成員的可用積分清零',
    userPoolLine1: '比賽結束，猜中冠軍比賽的用戶獲得個人瓜分獎池的資格',
    userPoolLine2: '所有猜中冠軍的用戶根據個人總積分瓜分獎池的 {percentage}%，瓜分結束後，個人可用積分清零。',
    poolFormula: '*例如，某團隊獲得瓜分資格的用戶有 N 個，每個人的積分依次以 N1、N2、N3...Nn表示，瓜分時的總獎池金額為A，該次瓜分獎池的比例是 20%，隊長獎勵比例 20%，則團隊成員獲得獎金 = [(A*20%)(1-0.2)/(N1+N2+N3+...+Nn)]*個人總積分',
    teamRule1: '1.只有一級代理可以發起組隊，如果不是代理，可申請成爲代理之後組建戰隊',
    teamRule2: '2.如果既不是代理，也無法獲得代理資格，則可以加入平臺設定的自由戰隊（不屬於代理的用戶）',
    teamRule3: '3.代理組建戰隊後，與其團隊成員自動成爲一個戰隊',
    teamRule4: '4.團隊總積分=戰隊成員積分總和+團隊任務獎勵積分',
    teamRule5: '5.團隊成員瓜分獎池的資格要求：活動期間參與競猜≥{quizTimesThreshold}次 + 永續合約交易量≥{poolContractThreshold}U',
    predictRule1: '1.比賽開始後將會關閉競猜',
    predictRule2: '2.每場比賽每個用戶僅可參與競猜 1 次',
    predictRule3: '3.競猜需要支付 {betPaymentAmount} USDT',
    predictRule4: '4.猜對獲勝隊伍 +{correctBonusPoints} 積分，猜錯 +{wrongBonusPoints} 積分',
    predictRule5: '5.如果對戰（小組賽）是“平局”則 按照猜錯計算積分，+{wrongBonusPoints} 積分',
    exchangeRule1: '1.獎品數量有限，兌完爲止；先到先得',
    exchangeRule2: '2.獎品兌換後扣除相應的積分，你所在團隊積分相應扣除',
    exchangeRule3: '3.兌換獎品時填寫聯繫方式，平臺工作人員會聯繫後續的獎品發放事宜',
    exchangeRule4: '4.兌換時填寫的聯繫方式有誤會造成兌換獎品受阻，請仔細確認和核對並持續關注消息',
    exchangeRule5: '5.如果長時間未收到平臺聯繫，請主動聯繫平臺客服處理',
    timeTitle: '活動時間',
    activePeriodLabel: '活動有效時間：',
    activePeriodValue: '{startTime} ~ {endTime}',
    activeTip: '活動開始後才計算和統計積分，獎池開始累積增加',
    predictPeriodLabel: '競猜時間：',
    predictPeriodValue: '冠軍競猜：{startTime} ~ {endTime}',
    businessTitle: '業務規則',
    businessRule1: '1. 有效邀請用戶：有效邀請指受邀請人充值≥{inviteRechargeThreshold}U，永續合約交易量≥{contractVolumeThreshold}U',
    businessRule2: '2. 團隊成員瓜分獎池的資格要求：活動期間參與競猜≥{quizTimesThreshold}次 + 永續合約交易量≥{poolContractThreshold}U',
    businessRule3: '3. 個人積分可隨時進行禮品兌換，兌換後個人及團隊相應積分扣除',
    businessRule4: '4. 實物獎品數量有限，兌完爲止',
    businessRule5: '5. 世界盃門票兌換截止世界盃開幕前一日，因不可抗力因素導致無法兌換實物門票可兌換等值USDT',
    statementTitle: '嚴正聲明',
    statement1: '1. 每位用戶僅限使用一個賬戶參與活動，嚴禁使用多個賬戶（包括但不限於批量註冊賬戶、關聯賬戶等）參與活動，系統將對參與賬戶的登錄設備及IP地址進行監測，若發現多個賬戶使用同一設備或同一IP地址進行操作，平臺有權判定爲關聯賬戶；',
    statement2: '2. 用戶參與活動的交易行爲必須真實有效，嚴禁任何形式的對刷交易、對敲交易或自成交行爲',
    statement3: '3. 平臺將通過風控系統識別異常交易行爲，包括但不限於：高頻反向開平倉、同價位對沖交易、低風險套利刷量行爲',
    statement4: '4. 一經發現異常交易行爲，平臺有權：清除該部分交易產生的積分、取消用戶活動參與資格、凍結或回收相關獎勵',
    statement5: '5. 獎池金額及獎勵分配以平臺最終統計結果爲準，平臺保留對本活動規則的最終解釋權',
  },
  exchange: {
    needPoints: '所需積分',
    stock: '剩餘庫存',
    buyNow: '立即兌換',
    soldOut: '已售罄',
    badgeUnique: '全站唯一大獎',
    badgeOnlyCount: '僅{count}件',
    itemFinalTicket: '世界盃決賽門票',
    itemSignedFootball: '簽名足球',
  },
  task: {
    earnPoints: '賺積分',
    goFinish: '去完成',
    goTeamTask: '做任務賺取團隊積分',
  },
  taskGroup: {
    daily: '每日任務',
    invite: '邀請任務',
    recharge: '充值任務',
    teamTrade: '團隊交易任務',
    dailyLimitPrefix: '每日獎勵上限',
    teamLimitPrefix: '團隊每日獎勵上限',
    limitPoints: '{num}積分',
    limitSuffix: '，每日00:00:00 (GMT+08:00) 刷新',
    rechargeLimitSuffix: '僅計算活動期間首次充值是否達標',
    inviteCta: '立即邀請賺積分',
    taskPredictOnce: '每參與一次賽事競猜',
    taskTrade10000: '每累計完成永續合約交易量 {tradeVolume}U',
    taskInviteValidUser: '每完成一位有效用戶邀請',
    taskInviteRegister: '邀請好友註冊',
    taskInviteKyc: '邀請好友完成KYC',
    taskInviteRecharge: '邀請好友完成首次充值',
    taskFirstRecharge: '首次充值 >= {amount} USDT',
    taskTeamTrade10000: '每累計完成{tradeVolume} USDT永續合約交易額，團隊+{teamBonusPoints}積分',
  },
};
export {
  apis,
  games,
  h5,
  trading,
  download,
  login,
  user,
  advertise,
  otcMerchant,
  otc,
  menu,
  time,
  state,
  text,
  seckillRes,
  header,
  hyy,
  index,
  indexPage,
  Verification,
  NAVS,
  FOOTERS,
  SIDEBAR,
  seckill,
  apply,
  recommend,
  market,
  banner,
  card,
  news,
  info,
  navCard,
  choice,
  plat,
  risk,
  license,
  footer,
  merchandiser,
  codeInfo,
  placeOrder,
  tableList,
  codelist,
  contractHyy,
  common,
  dialog,
  panKou,
  invite,
  property,
  contest,
  taskCenter,
  ieo,
  earn,
  tradingContest,
  agent,
  live,
  hongbao,
  worldCup
};



// WEBPACK FOOTER //
// ./src/i18n/lang/public/tw.js